module.exports = __webpack_public_path__ + "img/teams-very-small-user.2dc000fb.svg";